import { render, staticRenderFns } from "./AllMagazinePosts.vue?vue&type=template&id=2fb5a2a5"
import script from "./AllMagazinePosts.vue?vue&type=script&lang=js"
export * from "./AllMagazinePosts.vue?vue&type=script&lang=js"
import style0 from "./AllMagazinePosts.vue?vue&type=style&index=0&id=2fb5a2a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports